import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import LeadButton from '@/components/LeadButton';
import MaxScreen from '@/components/Device/MaxScreen';
import MediumScreen from '@/components/Device/MediumScreen';
import SmallScreen from '@/components/Device/SmallScreen';
import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import useIsMobileNew from '@/hooks/useIsMobileNew';

const TeacherEvaluate = () => {
  const { t, i18n } = useTranslation(['whyWukong']);
  const isEn = i18n.language === 'en';
  const isSmallScreen = useIsMobileNew();
  const isSmallScreenAndIsEn = isEn && isSmallScreen;

  return (
    <div className="mt-[210px] lg:mt-[80px] xl:mt-[94px]">
      <MaxScreen>
        <div className="h-[304px] bg-[url(/images/reasonsForChoosing/study_plan_teacher_introduce_bg.png)] bg-cover bg-center bg-no-repeat" />
      </MaxScreen>
      <MediumScreen>
        <div className="h-[222px] bg-[url(/images/reasonsForChoosing/study_plan_teacher_introduce_bg_medium.png)] bg-cover bg-center bg-no-repeat" />
      </MediumScreen>
      <SmallScreen>
        <div className="h-[82px] bg-[url(/images/reasonsForChoosing/study_plan_teacher_introduce_bg_small.png)] bg-cover bg-center bg-no-repeat" />
      </SmallScreen>
      <div className="relative mx-auto rounded-[24px] bg-[rgba(255,255,255,0.50)] px-[20px] pb-[40px] pt-[70px] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] backdrop-blur-[25px] lg:mt-[-55px] lg:w-[870px] lg:rounded-[24px] lg:px-[32px] lg:pt-[80px] xl:mt-[-90px] xl:w-[870px] xl:rounded-[36px] xl:px-[32px] xl:pt-[80px]">
        <MaxAndMediumScreen>
          <div className="absolute right-[-15px] top-[-40px] flex h-[80px] w-[80px] rotate-[-15deg] items-center justify-center rounded-[20px] border-[1.67px] border-solid border-[#fff] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] text-[46px] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)]">
            👍
          </div>
        </MaxAndMediumScreen>
        <div className="absolute left-[50%] top-[-40px] h-[80px] w-[80px] translate-x-[-50%] overflow-hidden  rounded-full border-[6px] border-solid border-[#fff] lg:top-[-60px] lg:h-[120px] lg:w-[120px] xl:top-[-60px] xl:h-[120px] xl:w-[120px]">
          <Image
            src="/images/reasonsForChoosing/study_plan_bella.png"
            width={120}
            height={120}
            layout="responsive"
            alt={t('悟空国际中文教研老师')}
          />
        </div>
        <h3
          className="flex items-center justify-center text-wk-words-1"
          style={isSmallScreenAndIsEn ? { flexDirection: 'column', textAlign: 'center' } : {}}
        >
          <span
            className="text-[16px]"
            style={{ fontWeight: isEn ? 700 : 600, marginBottom: isSmallScreenAndIsEn ? 8 : 0 }}
          >
            {t('Bella')}
          </span>
          {isSmallScreenAndIsEn ? null : <div className="mx-[8px] h-[12px] w-[1px] bg-[#8D8FA6]  text-[14px]" />}
          <span className="font-medium">{t('悟空国际中文教研老师')}</span>
        </h3>
        <section className="relative mt-[24px] px-[32px] lg:px-[56px] xl:px-[56px]">
          <MaxAndMediumScreen>
            <svg
              className="absolute left-0 top-0"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5684 6.08168C7.54798 9.30583 4.75893 13.0585 4.20122 17.3396C3.33299 24.0044 9.29311 27.2666 12.313 24.3355C15.333 21.4044 13.5227 17.6841 11.336 16.6672C9.14924 15.6502 7.81198 16.0044 8.04525 14.6454C8.27851 13.2864 11.3896 9.51857 14.1228 7.76383C14.3041 7.60963 14.3731 7.31043 14.1985 7.08343C14.0836 6.93417 13.8584 6.6414 13.5227 6.20511C13.2292 5.8236 12.948 5.83788 12.5684 6.08168Z"
                fill="#EBECFA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.7856 6.08168C20.7653 9.30583 17.9762 13.0585 17.4185 17.3396C16.5503 24.0044 22.5104 27.2666 25.5304 24.3355C28.5503 21.4044 26.74 17.6841 24.5533 16.6672C22.3666 15.6502 21.0292 16.0044 21.2626 14.6454C21.4958 13.2864 24.6069 9.51857 27.3401 7.76383C27.5214 7.60963 27.5904 7.31043 27.4158 7.08343C27.301 6.93417 27.0757 6.6414 26.74 6.20511C26.4465 5.8236 26.1653 5.83788 25.7856 6.08168Z"
                fill="#EBECFA"
              />
            </svg>
            <svg
              className="absolute bottom-0 right-0"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4316 25.9264C24.452 22.7022 27.2411 18.9496 27.7988 14.6684C28.667 8.00369 22.7069 4.74149 19.687 7.67255C16.667 10.6036 18.4773 14.324 20.664 15.3409C22.8508 16.3579 24.188 16.0037 23.9548 17.3627C23.7215 18.7216 20.6104 22.4895 17.8772 24.2442C17.6959 24.3984 17.6269 24.6976 17.8015 24.9246C17.9164 25.0739 18.1416 25.3667 18.4773 25.8029C18.7708 26.1845 19.052 26.1702 19.4316 25.9264Z"
                fill="#EBECFA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.21437 25.9264C11.2347 22.7022 14.0238 18.9496 14.5815 14.6684C15.4497 8.00369 9.48957 4.74149 6.46964 7.67255C3.4497 10.6036 5.25997 14.324 7.4467 15.3409C9.63344 16.3579 10.9708 16.0037 10.7374 17.3627C10.5042 18.7216 7.3931 22.4895 4.6599 24.2442C4.47857 24.3984 4.40957 24.6976 4.58424 24.9246C4.69904 25.0739 4.9243 25.3667 5.25997 25.8029C5.5535 26.1845 5.8347 26.1702 6.21437 25.9264Z"
                fill="#EBECFA"
              />
            </svg>
          </MaxAndMediumScreen>
          <SmallScreen>
            <svg
              className="absolute left-0 top-0"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.92641 4.5583C5.16111 6.97642 3.06932 9.79092 2.65104 13.0018C1.99986 18.0003 6.46996 20.447 8.73491 18.2487C10.9999 16.0504 9.64216 13.2601 8.00211 12.4974C6.36206 11.7347 5.35911 12.0003 5.53406 10.9811C5.70901 9.96187 8.04231 7.13597 10.0922 5.81992C10.2282 5.70427 10.28 5.47987 10.149 5.30962C10.0629 5.19767 9.8939 4.97809 9.64215 4.65088C9.422 4.36474 9.21111 4.37545 8.92641 4.5583Z"
                fill="#EBECFA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8395 4.5583C15.0742 6.97642 12.9824 9.79092 12.5641 13.0018C11.913 18.0003 16.3831 20.447 18.648 18.2487C20.913 16.0504 19.5553 13.2601 17.9152 12.4974C16.2752 11.7347 15.2722 12.0003 15.4472 10.9811C15.6221 9.96187 17.9554 7.13597 20.0053 5.81992C20.1413 5.70427 20.1931 5.47987 20.0621 5.30962C19.976 5.19767 19.807 4.97809 19.5553 4.65088C19.3351 4.36474 19.1242 4.37545 18.8395 4.5583Z"
                fill="#EBECFA"
              />
            </svg>
            <svg
              className="absolute bottom-0 right-0"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0746 19.4417C17.8399 17.0236 19.9317 14.2091 20.3499 10.9983C21.0011 5.99971 16.531 3.55306 14.2661 5.75136C12.0011 7.94966 13.3588 10.7399 14.9989 11.5026C16.6389 12.2654 17.6419 11.9997 17.4669 13.019C17.292 14.0382 14.9587 16.8641 12.9088 18.1801C12.7728 18.2958 12.721 18.5202 12.852 18.6904C12.9381 18.8024 13.1071 19.0219 13.3588 19.3492C13.579 19.6353 13.7899 19.6246 14.0746 19.4417Z"
                fill="#EBECFA"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.16053 19.4417C7.92578 17.0236 10.0176 14.2091 10.4359 10.9983C11.087 5.99971 6.61693 3.55306 4.35198 5.75136C2.08703 7.94966 3.44473 10.7399 5.08478 11.5026C6.72483 12.2654 7.72783 11.9997 7.55283 13.019C7.37788 14.0382 5.04458 16.8641 2.99468 18.1801C2.85868 18.2958 2.80693 18.5202 2.93793 18.6904C3.02403 18.8024 3.19298 19.0219 3.44473 19.3492C3.66488 19.6353 3.87578 19.6246 4.16053 19.4417Z"
                fill="#EBECFA"
              />
            </svg>
          </SmallScreen>
          <p className="text-[16px] leading-[28px] text-wk-words-2 lg:text-[20px] lg:leading-[32px] xl:text-[20px] xl:leading-[32px]">
            {t('老师自述')}
          </p>
        </section>
      </div>
      <div className="mt-[24px] text-center lg:mt-[48px] xl:mt-[60px]">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_LearningAdvantage_CTAClick"
          traceGa4Name="new_entry_How_LearningAdvantageCTA"
        >
          {t('理由-立即体验')}
        </LeadButton>
      </div>
    </div>
  );
};

export default TeacherEvaluate;
